import { useCallback } from "react";

import { USER_ROLES_LABELS } from "@/constants/user.constants";
import { useT } from "@/i18n";
import { UserRole } from "@/types/user.types";

export const useGetUserRoleLabel = () => {
  const t = useT();

  const getUserRoleLabel = useCallback(
    (role: UserRole) => {
      return t(USER_ROLES_LABELS[role]);
    },
    [t]
  );

  return getUserRoleLabel;
};
